var skanGym = skanGym || {};

$(function () {
	skanGym.filter.init();
});

skanGym.filter = new function () {
	this.init = function () {
		skanGym.filter.teacherFilter($('.teacher-list', '#teachers-modules'), $('.teacher-list', '#employee-modules'));
		skanGym.filter.courseFilter($('.course-list', '#courses-module'));
	};

	this.teacherFilter = function($container, $employeesList) {
		// quick search regex
		var qsRegex,
			filters = {},
			classFilters = '';

		// Init isotope
		$container.imagesLoaded( function() {
			$container.isotope({
				itemSelector: '.teacher-item',
				layoutMode: 'fitRows',
				filter: function() {
					var isValid = true;

					if(isValid && qsRegex){
						var regexResult = $(this).find('span').text().match( qsRegex );
						isValid = regexResult != null && regexResult.length > 0;
					}
					if(isValid && classFilters != ''){
						isValid = $(this).hasClass(classFilters);
					}
					return isValid;
				}
			});
		});

		$employeesList.imagesLoaded( function(){
			$employeesList.isotope({
				itemSelector: '.teacher-item',
				layoutMode: 'fitRows'
			});
		});


		// Filtering on buttons
		$('#filters').on( 'click', 'button', function() {
			// Toggle active class
			$('button.active').removeClass('active');
			$(this).addClass('active');

			var itemClass = $(this).attr('data-filter');
			classFilters = itemClass.substr(1, itemClass.length);

			$container.isotope();
		});

		// Use value of search field to filter
		var $quicksearch = $('#quicksearch').keyup( debounce( function() {
			qsRegex = new RegExp( $quicksearch.val(), 'gi' );

			$container.isotope();
		}, 200 ) );

	};

	this.courseFilter = function($container) {
		$container.isotope({
			itemSelector: '.course-item'
		});

		// filter items on button click
		$('#filters').on( 'click', 'button', function() {
			var filterValue = $(this).attr('data-filter');
			$container.isotope({ filter: filterValue });
		});
	};
};

// debounce so filtering doesn't happen every millisecond
function debounce( fn, threshold ) {
	var timeout;
	return function debounced() {
		if ( timeout ) {
			clearTimeout( timeout );
		}
		function delayed() {
			fn();
			timeout = null;
		}
		timeout = setTimeout( delayed, threshold || 100 );
	};
}